import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.trim.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-66006668"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-shape container pt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("Account validation");

var _hoisted_3 = {
  class: "d-flex flex-column align-items-center text-center"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Go to Home");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Try again");

import { ref, reactive } from "vue";
import { useRoute } from "vue-router";
import { useLoadingBar } from "naive-ui";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import { getErrorMessage, handleError } from "@/utils/errors";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var userStore = useUserStore();
    var loadingBar = useLoadingBar();
    var LoaderState = LoaderStateEnum;
    var loaders = reactive({
      validation: LoaderStateEnum.Idle
    });
    var errors = reactive({});
    var invalidMessage = "Sorry, this link is no longer valid.";
    var invalid = ref(false);

    var validate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loadingBar.start();
                loaders.validation = LoaderStateEnum.Loading;
                _context2.prev = 2;
                _context2.next = 5;
                return userStore.validate({
                  token: route.query.t
                });

              case 5:
                loaders.validation = LoaderStateEnum.Loaded;
                loadingBar.finish();
                _context2.next = 16;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                _context2.next = 13;
                return handleError(_context2.t0, {
                  http: function () {
                    var _http = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                      var _e$response, _e$response2, _e$response2$data;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              invalid.value = ((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 400;
                              return _context.abrupt("return", invalid.value ? invalidMessage : getErrorMessage((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.errors));

                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function http(_x) {
                      return _http.apply(this, arguments);
                    }

                    return http;
                  }()
                });

              case 13:
                errors.validation = _context2.sent;
                loaders.validation = LoaderStateEnum.Failed;
                loadingBar.error();

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      return function validate() {
        return _ref.apply(this, arguments);
      };
    }();

    if (typeof route.query.t !== "string" || route.query.t.trim().length === 0) {
      invalid.value = true;
      errors.validation = invalidMessage;
      loaders.validation = LoaderStateEnum.Failed;
    }

    if (!invalid.value) {
      validate();
    }

    return function (_ctx, _cache) {
      var _component_n_h1 = _resolveComponent("n-h1");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_button = _resolveComponent("n-button");

      var _component_router_link = _resolveComponent("router-link");

      var _component_n_spin = _resolveComponent("n-spin");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_h1, null, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }), _createVNode(_component_n_spin, {
        size: 76,
        show: _unref(loaders).validation === _unref(LoaderState).Loading
      }, {
        default: _withCtx(function () {
          var _unref$user;

          return [_unref(loaders).validation === _unref(LoaderState).Loading ? (_openBlock(), _createBlock(_component_n_result, {
            key: 0,
            class: "invisible"
          }, {
            icon: _withCtx(function () {
              return [_createVNode(_component_n_skeleton, {
                sharp: false,
                class: "skeleton-item icon d-inline-block"
              })];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_n_skeleton, {
                class: "skeleton-item title mb-4"
              }), _createVNode(_component_n_skeleton, {
                class: "skeleton-item message"
              })])];
            }),
            _: 1
          })) : _unref(loaders).validation !== _unref(LoaderState).Failed ? (_openBlock(), _createBlock(_component_n_result, {
            key: 1,
            status: "success",
            title: "Success",
            description: "Thank you ".concat((_unref$user = _unref(userStore).user) === null || _unref$user === void 0 ? void 0 : _unref$user.userName, ", your account has been validated.")
          }, {
            footer: _withCtx(function () {
              return [_createVNode(_component_router_link, {
                to: {
                  name: 'Home'
                },
                class: "text-decoration-none"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_button, null, {
                    default: _withCtx(function () {
                      return [_hoisted_4];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["description"])) : (_openBlock(), _createBlock(_component_n_result, {
            key: 2,
            status: "error",
            title: invalid.value ? 'Invalid link' : 'Error',
            description: _unref(errors).validation
          }, _createSlots({
            _: 2
          }, [!invalid.value ? {
            name: "footer",
            fn: _withCtx(function () {
              return [_createVNode(_component_n_button, {
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return validate();
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_5];
                }),
                _: 1
              })];
            })
          } : undefined]), 1032, ["title", "description"]))];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});